import React, { useEffect, useState } from "react"
import {
  Dropdown,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  Table,
} from "reactstrap"

import downArrowIcon from "../../../assets/images/icons/down-arrow-color.svg"
import { useLazyGetDashboardTopPerformerQuery } from "store/api/wealthpartnerapi/wealthReport"
import { formatAmount } from "helpers/common"
const defaultFilters = {
  search: "",
  page: 1,
  pageSize: 100,
  timestamp: "",
  period: "This Year",
}
const periods = [
  "This Year",
  "This Half Year",
  "This Quarter",
  "This Month",
  "This Week",
]

const TopPerfomer = () => {
  const [dropdownOpen, setDropdownOpen] = useState(false)
  const toggle = () => setDropdownOpen((prevState) => !prevState)
  const [filters, setFilters] = useState(defaultFilters)
  const [data, setData] = useState([])
  const [getResults, { isFetching }] = useLazyGetDashboardTopPerformerQuery()

  const getList = async () => {
    try {
      const { data } = await getResults(filters).unwrap()
      setData(data)
    } catch (e) {}
  }

  useEffect(() => {
    getList()
  }, [filters])

  return (
    <React.Fragment>
      <div className="container-inner-right-box">
        <div className="filter-section">
          <h4>Top Performer</h4>
          <div className="dropdown-section">
            <Dropdown isOpen={dropdownOpen} toggle={toggle}>
              <DropdownToggle caret size="lg">
                {filters.period} <img src={downArrowIcon} alt="" />
              </DropdownToggle>
              <DropdownMenu style={{ minWidth: "auto" }}>
                {periods.map((item, index) => (
                  <DropdownItem
                    key={`periods_${index}`}
                    onClick={() => setFilters({ period: item })}
                  >
                    {item}
                  </DropdownItem>
                ))}
              </DropdownMenu>
            </Dropdown>
          </div>
        </div>
        <div className="investor-table-wrapper">
          <Table responsive>
            <thead>
              <tr>
                <th
                  style={{
                    backgroundColor: "#1667AD",
                  }}
                  className="name"
                >
                  Name
                </th>
                <th
                  style={{
                    backgroundColor: "#1C7ED2",
                  }}
                >
                  <div className="text-center">Total Commission Earned</div>
                </th>
              </tr>
            </thead>
            <tbody>
              {data.map((item, index) => (
                <tr key={`top_performer_${index}`}>
                  <td>{item.name}</td>
                  <td>
                    <div className="text-center">
                      ₹ {formatAmount(item.commission)}
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        </div>
      </div>
    </React.Fragment>
  )
}

export default TopPerfomer
